import React, { useRef, useState, useEffect } from "react";
import cssClasses from "../AllAllotments.module.css";
import { Box, Card, CardActions, Checkbox, Grid, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import {
  approveTagCrmAllotment,
  getCRMTimelineData,
  getTagPendingCrmAllotments,
  getVirtualAccDetailsById,
  insertCRMLogs,
  rejectTagCrmAllotment,
  sendWhatsappMessageOnTagApprove,
} from "../../../Services/AllAllotments";
import { errorTost, successTost } from "../../../Services/Toast";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { makeStyles } from "@mui/styles";
import ReactTimeAgo from "react-time-ago";
import Button from "../../../Subcomponents/Button";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import RejectionReasonModal from "./RejectionReasonModal/RejectionReasonModal";
import { isCrm2Booking } from "../../../Services/Crm2Tracker";
import { crm2AcceptTag, crm2RejectTag } from "../../../Services/Crm2List";
import SearchBar from "../../../Subcomponents/Search";
import _, { debounce } from "lodash";
import AllotmentFilter from "./AllotmentFilter";
import ViewToggleSwitch from "../../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import AllotmentSortFilter from "./AllotmentSortFIlter";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import ServerPaginationGrid from "../../ServerPaginationGrid";
import { supabase } from "../../../supabaseClient";
import { getLeadVirtualAccountStatus } from "../../../Services/Lead";
import UpdateLeadDetails from "./CheckVirtualAccountStatus/CheckVirtualAccountStatus";
import CrmTimeLineModal from "./CRMTimeLineModal/CrmTimeLineModal";
import CancelUnit from "../../../Modals/CancelUnit.js/CancelUnit";
import SelectCrmUserModal from "../SelectCrmUserModal/SelectCrmUserModal";
import { getCRMUsersFromUserTable } from "../../../Services/Users";
const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

function TagPending() {
  const classes = useStyles();

  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allCrmAllotments, setAllCrmAllotments] = useState([]);
  const hasMore = useRef(true);
  const pageNumber = useRef(0);
  const searchValue = useRef("");

  const [selectedCrmForApproveTag, setSelectedCrmForApproveTag] =
    useState(null);
  const [selectedCrmForRejectTag, setSelectedCrmForRejectTag] = useState(null);
  const [mode, setMode] = useState("Card View");
  const [selectedAllotments, setSelectedAllotments] = useState([]);
  const [selectedAllotmentDataToApprove, setSelectedAllotmentDataToApprove] =
    useState([]);
  const [showApproveAlert, setShowApproveAlert] = useState(false);
  const [selectBtnName, setSelectBtnName] = useState("Select All");
  const [checked, setChecked] = React.useState([]);
  const [filterBy, setFilterBy] = useState("Latest First");
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [depStr, setDepQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [leadDisplayId, setLeadDisplayId] = useState("")
  const [virtualAccountStatusModal, setVirtualAccountStatusModal] = useState(false)
  const [crmTimeLineModalToggle, setcrmTimeLineModalToggle] = useState(false);
  const [allotmentData, setAllotmentData] = useState([])
  const isInitialRender = useRef(true);
  const [cancelUnitModal, setCancelUnitModal] = useState(false);
  const [leadObj, setLeadObj] = useState(null);
  const [selectedAllotment, setSelectedAllotment] = useState(null);
  const [reassignCRMModal, setReassignCRMModal] = useState(false);
  const [reassignCRMAllotment, setReassignCRMAllotment] = useState(null);
  const [crmUsers, setCrmUsers] = useState([]);

  useEffect(() => {
    // if (loggedInUser?.isCrmUser && loggedInUser?.id) {
    if (loggedInUser?.id && allCrmAllotments?.length === 0) {
      getCrmAllotmentsFromServer(false);
    }
    getCRMUsersFromUserTable()
      .then((crmUsersRes) => {
        crmUsersRes.data.forEach((ele) => {
          ele.label = ele.name;
          ele.value = ele.name;
        });
        setCrmUsers([...crmUsersRes.data]);
      })
      .catch((err) => {
        console.error(err.message);
      });
  }, [loggedInUser]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      getCrmAllotmentsFromServer(false);
    }
  }, [filterBy]);


  useEffect(() => {
    let updateUnitListener = supabase
      // .from(`CRM:requestPendingWith=eq.${loggedInUser?.id}`)
      .from(
        `CRM${!loggedInUser?.parentId
          ? ""
          : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
            "Show CRM"
          ]?.show === "All"
            ? ""
            : `:requestPendingWith=eq.${loggedInUser?.id}`
        }`
      )
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
        if (searchValue.current !== "") {
          allCrmAllotments.forEach((allotment, index) => {
            if (
              allotment?.allotment_payment_id ===
              handleRecordUpdated?.new?.allotmentPaymentId
            ) {
              getCrmAllotmentsFromServer(false);
            }
          });
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, [allCrmAllotments]);

  useEffect(() => {
    let updateUnitListener = supabase
      .from(`AllotmentPayment`)
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
        if (searchValue.current !== "") {
          allCrmAllotments.forEach((allotment, index) => {
            if (
              allotment?.allotment_payment_id ===
              handleRecordUpdated?.new?.allotmentPaymentId
            ) {
              getCrmAllotmentsFromServer(false);
            }
          });
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });

    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, [allCrmAllotments]);

  const tagGridColumns = [
    {
      field: "action",
      headerName: "",
      // flex: 1,
      // width: showDropDown ? 200 : 160,
      width: 100,
      renderCell: (params) => {
        return (
          <div className={cssClasses.actionDiv}>
            <div>
              <Checkbox
                style={{ width: "2rem", height: "2rem", transform: "scale(2)" }}
                checked={
                  selectedAllotments.filter((val) => val?.id === params.id)
                    .length > 0
                    ? true
                    : false
                }
                onChange={(e) => {
                  const payload = [...selectedAllotments];
                  if (e.target.checked) {
                    payload.push(params?.row);
                    setSelectedAllotments(payload);
                    setSelectedAllotmentDataToApprove(payload);
                  } else {
                    const index = selectedAllotments.findIndex(
                      (val) => val?.id === params?.id
                    );
                    payload.splice(index, 1);
                    setSelectedAllotments(payload);
                    setSelectedAllotmentDataToApprove(payload);
                  }

                  if (payload?.length === allCrmAllotments?.length) {
                    setSelectBtnName("Remove All");
                  } else {
                    setSelectBtnName("Select All");
                  }
                }}
              />
              <ThreeDotsMenu
                // list={["Details", "Sync", "Check Status"]}
                // list={[
                //   "Send Test Mail",
                //   "Send Email To Customer",
                //   "View CRM Details",
                // ]}
                list={params.row?.menuOptions}
                selectedValue={(e) => {
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(params.row?.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                  if (e === "Reject Tag") {
                    setSelectedCrmForRejectTag({ ...params.row });
                  }
                  if (e === "Timeline And Notes") {
                    setAllotmentData(params?.row);
                    setcrmTimeLineModalToggle(true);
                  }
                  if (e === "Cancel Unit") {
                    let leadobj = {
                      leadId: params.row?.lead_id,
                      leadname: params.row?.lead_name,
                      leademail: params.row?.lead_email,
                      leadcontactnumber: params.row?.bookingformcontactnumber,
                      leaddisplayid: params.row?.leaddisplayid.toString(),
                    };
                    let allotmentObj = {
                      allotmentPaymentId: params.row?.allotment_payment_id,
                    };
                    setLeadObj(leadobj);
                    setSelectedAllotment(allotmentObj);
                    setCancelUnitModal(true);
                  }
                  if (e === "Reassign CRM") {
                    setReassignCRMAllotment(params?.row);
                    setReassignCRMModal(true);
                  }
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "unit",
      headerName: "Unit",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {params?.row?.displaywingname
                      ? params?.row?.displaywingname
                      : params?.row?.wing_name}{" "}
                    - {params?.row?.unit_no}{" "}
                  </span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {/* {params?.row?.merged_wing_name} -{" "} */}
                    {params?.row?.mergeddisplaywingname
                      ? params?.row?.mergeddisplaywingname
                      : params?.row?.merged_wing_name}{" "}
                    - {params?.row?.merged_unit_no_one} {"-"}{" "}
                    {params?.row?.merged_unit_no_two}{" "}
                  </span>
                )}
              </div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>{params?.row?.project_name}</span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>{params?.row?.merged_project_name}</span>
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "allotmentId",
      headerName: "Allotment Id",
      width: 200,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>{params.row?.allotment_payment_id}</p>
              </div>
            }
          >
            <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
              {params.row?.allotment_payment_id}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "leadsDetails",
      headerName: "Leads Name",
      width: 230,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p style={{ whiteSpace: "break-spaces" }}>
                  {params.row?.lead_name}
                </p>
              </div>
            }
          >
            <div>
              <p style={{ whiteSpace: "break-spaces" }}>
                {params.row?.lead_name}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "sdrStatus",
      headerName: "SDR Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {!params?.row?.sdrcomplete ? (
                  <LeadStatusChip
                    label={"SDR Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#B54708",
                      backgroundColor: "#FFFAEB",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"SDR Complete"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "rgb(2, 122, 72)",
                      backgroundColor: "rgb(236, 253, 243)",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "event",
      headerName: "Event",
      width: 210,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {params.row.event_title
                    ? params.row.event_title
                    : "Sustenance"}
                </p>
              </div>
            }
          >
            <div
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "break-spaces",
              }}
            >
              {params.row.event_title ? params.row.event_title : "Sustenance"}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "vjSm",
      headerName: "VJ SM",
      width: 160,
      renderCell: (params) => {
        return <div>{params.row.sales_user_name}</div>;
      },
    },
    {
      field: "vjCrm",
      headerName: "VJ CRM",
      width: 180,
      renderCell: (params) => {
        return <div>{params.row.crm_user_name}</div>;
      },
    },
    {
      field: "allotedOn",
      headerName: "Alloted On",
      width: 250,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.created_at).toDateString()},{" "}
                  {new Date(params?.row?.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.created_at).toDateString()},{" "}
                {new Date(params?.row?.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      width: 270,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                  {new Date(params?.row?.last_updated_at).toLocaleTimeString(
                    [],
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                {new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  async function getFilterAllotmentForDatagrid(nextRange = { from: 0, to: 9 }) {
    let items = await getFilterAllotmentPagination(false, true, nextRange);
    return items;
  }

  async function getFilterAllotmentPagination(
    merge = false,
    isShowSpinner = true,
    nextRange
  ) {
    //setAllAllotments([])
    try {
      const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Show CRM']?.show === 'All' ? null : loggedInUser?.id;
      const getTagPendingAllotmentsResponse = await getTagPendingCrmAllotments(
        _loggedInUserId,
        pageNumber?.current,
        searchValue?.current,
        filterBy,
        checked,
        selectDates,
        nextRange,
        true
      );

      if (getTagPendingAllotmentsResponse.data) {
        // setSelectBtnName("Select All");
        // setSelectedAllotments([]);
        selectBtnName === "Select All" ? setSelectBtnName("Select All") : setSelectBtnName("Remove All");
        selectBtnName === "Remove All" ? setSelectedAllotments(getTagPendingAllotmentsResponse?.data) : setSelectedAllotments([]);

        setTotalCount(getTagPendingAllotmentsResponse.count);
        if (getTagPendingAllotmentsResponse.data) {
          setTotalCount(getTagPendingAllotmentsResponse.count);

          getTagPendingAllotmentsResponse.data.forEach((crmData) => {
            crmData.menuOptions = [
              "Reject Tag", "Check Virtual Account Status",
              "Timeline And Notes"
            ];
            if (
              crmData?.status !== "Released" &&
              crmData?.status !== "Change Requested" &&
              crmData?.status !== "Change Rejected" &&
              crmData?.status !== "Cancellation Requested" &&
              crmData?.status !== "Cancellation Rejected" &&
              crmData?.status !== "Cancellation Pending" &&
              crmData?.status !== "Cancellation Not Done" &&
              crmData?.status !== "Cancelled" &&
              // allotment?.status !== "Partial Payment Done" &&
              !crmData?.status.includes("Refund") &&
              (!crmData?.b2b_100_res && !crmData?.gst_b2b_res && !crmData?.sdr_b2b_res)
            ) {
              // !!Remaining user access condition
              if (
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["CRM"]?.[
                  "Cancel Unit"
                ]?.isAccessible) {
                crmData.menuOptions.push("Cancel Unit");
              }
            }
            if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Tag Pending"]?.["Reassign CRM"]?.isAccessible) {
              crmData.menuOptions.push("Reassign CRM");
            }
            crmData.menuOptions.sort();
          });

          if (!merge && getTagPendingAllotmentsResponse.data.length) {
            let res = getTagPendingAllotmentsResponse.data;

            if (!merge) {
              setAllCrmAllotments((pre) => [...res]);
              isShowSpinner && dismissLoader();
            } else {
              setAllCrmAllotments((pre) => [...pre, ...res]);
              isShowSpinner && dismissLoader();
            }
          }
          return getTagPendingAllotmentsResponse.data;
        }
      }
    } catch (err) {
      if (err?.message) {
        errorTost(err?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
    }
  }

  useEffect(() => {
    getCrmAllotmentsFromServer(false);
  }, [filterBy]);

  async function getCrmAllotmentsFromServer(merge, isCheckedClear = false) {
    if (!merge) {
      pageNumber.current = 0;
      hasMore.current = true;
      // setChecked([]);
    }
    mode === "Table View" && setAllCrmAllotments([]);
    const selectedDate = { ...selectDates };
    try {
      presentLoader();
      // const _loggedInUserId = loggedInUser?.roleId?.accessibleTabs?.[
      //   "All Allotments"
      // ]?.CRM?.["Tag Pending"]?.["Approve Tag"]?.isAccessible
      //   ? null
      //   : !loggedInUser?.parentId
      //     ? null
      //     : loggedInUser?.id;
      const _loggedInUserId = !loggedInUser?.parentId
        ? null
        : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Show CRM"
        ]?.show === "All"
          ? null
          : loggedInUser?.id;
      await getTagPendingCrmAllotments(
        _loggedInUserId,
        pageNumber.current,
        searchValue?.current,
        filterBy,
        checked,
        isCheckedClear ? undefined : selectedDate
      )
        .then((getTagPendingCrmAllotmentsResponse) => {
          setTotalCount(getTagPendingCrmAllotmentsResponse.count);
          if (
            getTagPendingCrmAllotmentsResponse &&
            getTagPendingCrmAllotmentsResponse.data
          ) {
            getTagPendingCrmAllotmentsResponse.data.forEach((crmData) => {
              crmData.menuOptions = ["Check Virtual Account Status", "Timeline And Notes"];
              if (
                crmData?.status !== "Released" &&
                crmData?.status !== "Change Requested" &&
                crmData?.status !== "Change Rejected" &&
                crmData?.status !== "Cancellation Requested" &&
                crmData?.status !== "Cancellation Rejected" &&
                crmData?.status !== "Cancellation Pending" &&
                crmData?.status !== "Cancellation Not Done" &&
                crmData?.status !== "Cancelled" &&
                // allotment?.status !== "Partial Payment Done" &&
                !crmData?.status.includes("Refund") &&
                (!crmData?.b2b_100_res && !crmData?.gst_b2b_res && !crmData?.sdr_b2b_res)
              ) {
                // !!Remaining user access condition
                if (
                  loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["CRM"]?.[
                    "Cancel Unit"
                  ]?.isAccessible) {
                  crmData.menuOptions.push("Cancel Unit");
                }
              }
              if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Tag Pending"]?.["Reassign CRM"]?.isAccessible) {
                crmData.menuOptions.push("Reassign CRM");
              }
              crmData.menuOptions.sort();
            });

            if (merge) {
              setAllCrmAllotments((pre) => [
                ...pre,
                ...getTagPendingCrmAllotmentsResponse.data,
              ]);
            } else {
              setAllCrmAllotments([...getTagPendingCrmAllotmentsResponse.data]);
            }
            if (getTagPendingCrmAllotmentsResponse.data.length < 10) {
              hasMore.current = false;
            }
            dismissLoader();
          } else {
            throw getTagPendingCrmAllotmentsResponse;
          }
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
    } catch (error) {
      if (error?.status === 416) {
        hasMore.current = false;
      } else if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  // CRM2 M2-F6 (M2.6): a CRM 2.0 booking is accepted / rejected through the CRM 2.0 routes
  // (Day 0, Application email, next CRM in turn); old bookings keep the code below unchanged.
  async function crm2TagDecision(row, what, reason = "") {
    try {
      presentLoader();
      const res = what === "accept" ? await crm2AcceptTag(row?.allotment_payment_id) : await crm2RejectTag(row?.allotment_payment_id, reason);
      console.log("[crm2][TagPending] CRM 2.0 tag decision", { what, allotmentPaymentId: row?.allotment_payment_id, status: res?.status });
      successTost(what === "accept" ? "Booking accepted. Email sent to the customer." : res?.status === "UNCLAIMED" ? "Tag rejected. No other CRM left — it is now Unclaimed." : `Tag rejected. Passed to ${res?.nextCrmName || "the next CRM"}.`);
      getCrmAllotmentsFromServer(false);
    } catch (err) {
      console.error("[crm2][TagPending] CRM 2.0 tag decision failed", { what, allotmentPaymentId: row?.allotment_payment_id, message: err?.response?.data?.message });
      errorTost(err?.response?.data?.message || "Something went wrong! Try again");
    } finally {
      dismissLoader();
    }
  }
  const [crm2RejectRow, setCrm2RejectRow] = useState(null);

  async function approveCrmAllotmentTagToServer(val = {}) {
    if (
      (!selectedCrmForApproveTag || !selectedCrmForApproveTag?.id) &&
      selectedAllotmentDataToApprove?.length === 0
    ) {
      errorTost("Something went wrong! Try again");
      return;
    }
    const crm2Row = selectedAllotmentDataToApprove?.length > 0 ? val : selectedCrmForApproveTag;
    if (await isCrm2Booking(crm2Row?.allotment_payment_id).catch(() => false)) {
      setSelectedCrmForApproveTag(null);
      await crm2TagDecision(crm2Row, "accept");
      return;
    }

    try {
      presentLoader();
      await approveTagCrmAllotment(
        selectedAllotmentDataToApprove?.length > 0
          ? val?.id
          : selectedCrmForApproveTag?.id
      )
        .then(async (approveTagCrmAllotmentResponse) => {
          if (
            approveTagCrmAllotmentResponse.data &&
            approveTagCrmAllotmentResponse?.data?.id
          ) {
            let _index = allCrmAllotments.findIndex(
              (f) => f.id === approveTagCrmAllotmentResponse?.data?.id
            );
            if (_index) {
              allCrmAllotments[_index].isTagApprove =
                approveTagCrmAllotmentResponse?.data?.isTagApprove;
              setAllCrmAllotments([...allCrmAllotments]);
            }
            let whatsappToast = "";
            //Send Whatsapp Message 
            await sendWhatsappMessageOnTagApprove(selectedCrmForApproveTag?.lead_name,
              selectedCrmForApproveTag?.bookingformcontactnumber,
              selectedCrmForApproveTag?.project_name,
              selectedCrmForApproveTag?.crm_user_name,
              selectedCrmForApproveTag?.crm_user_contact,
              selectedCrmForApproveTag?.crm_user_email,
              selectedCrmForApproveTag?.unit_no
            ).then((res) => {
              console.log("Whatsapp", res);
              whatsappToast = "Whatsapp message sent successfully."
            }).catch((err) => {
              console.log("err", err);
              whatsappToast = "Error while sending whatsapp message."
            })
            setSelectedCrmForApproveTag(null);
            successTost(`CRM allotment approved successfully. ${whatsappToast}`);
            getCrmAllotmentsFromServer(false);
            dismissLoader();
            const crmObj = {
              message: `${selectedCrmForApproveTag?.crm_user_name} is tag approved for allotment unit ${selectedCrmForApproveTag?.unit_no} of project ${selectedCrmForApproveTag?.project_name} by ${loggedInUser?.name}`,
              allotmentPaymentId:
                selectedCrmForApproveTag?.allotment_payment_id,
              crmStatus: "Tag approved",
            };
            insertCRMLogs(crmObj)
              .then((res) => {
                console.log("Logs saved", res);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            throw approveTagCrmAllotmentResponse;
          }
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
    } catch (error) {
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      setSelectedCrmForApproveTag(null);
      dismissLoader();
    }
  }

  async function rejectCrmAllotmentTagToServer() {
    if (!selectedCrmForRejectTag || !selectedCrmForRejectTag?.id) {
      errorTost("Something went wrong! Try again");
      return;
    }
    if (await isCrm2Booking(selectedCrmForRejectTag?.allotment_payment_id).catch(() => false)) {
      // CRM 2.0: never deleted; ask for the reason, then pass it to the next CRM
      setCrm2RejectRow(selectedCrmForRejectTag);
      setSelectedCrmForRejectTag(null);
      return;
    }
    try {
      presentLoader();
      //Insert Deleted Logs
      const crmObj = {
        message: `${selectedCrmForRejectTag?.crm_user_name} is rejected for allotment unit ${selectedCrmForRejectTag?.unit_no} of project ${selectedCrmForRejectTag?.project_name} by ${loggedInUser?.name}`,
        allotmentPaymentId: selectedCrmForRejectTag?.allotment_payment_id,
        crmStatus: "Tag rejected",
      };
      await insertCRMLogs(crmObj)
        .then(async (res) => {
          console.log("Logs saved", res);
          //Delete from CRM table
          await rejectTagCrmAllotment(selectedCrmForRejectTag?.id).then((rejectTagCrmAllotmentResponse) => {
            if (
              rejectTagCrmAllotmentResponse.data &&
              rejectTagCrmAllotmentResponse?.data?.id
            ) {
              setSelectedCrmForRejectTag(null);
              successTost("CRM allotment rejected successfully.");
              getCrmAllotmentsFromServer(false);
              dismissLoader();
            } else {
              throw rejectTagCrmAllotmentResponse;
            }
          })
            .catch((err) => {
              console.log(err);
              errorTost("Something went wrong! Try again");
              setSelectedCrmForRejectTag(null);
              dismissLoader();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      setSelectedCrmForApproveTag(null);
      dismissLoader();
    }
  }

  const debouncedFetchSearchData = debounce((e) => {
    searchValue.current = e.target.value;
    pageNumber.current = 0;
    hasMore.current = true;
    getCrmAllotmentsFromServer(false);
  }, 800);

  const allotmentCard = allCrmAllotments.map((allotment, index) => {
    return (
      <Grid
        className={classes.Grid}
        item
        xs={4}
        sm={4}
        md={4}
        lg={4}
        key={"allotmentCard" + index}
      >
        <Card className={cssClasses.eventWrap} key={allotment?.id}>
          <div className={cssClasses.cardHeader}>
            <div className={cssClasses.tokenNumWrap}>
              {!allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {allotment?.displaywingname
                    ? allotment?.displaywingname
                    : allotment?.wing_name}{" "}
                  - {allotment?.unit_no}{" "}
                </span>
              )}
              {allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {/* {allotment?.merged_wing_name} -{" "} */}
                  {allotment?.mergeddisplaywingname
                    ? allotment?.mergeddisplaywingname
                    : allotment?.merged_wing_name}{" "}
                  - {allotment?.merged_unit_no_one} {"-"}{" "}
                  {allotment?.merged_unit_no_two}{" "}
                </span>
              )}
              <span>|</span>
              {!allotment?.inventory_merge_id && (
                <span>{allotment?.project_name}</span>
              )}
              {allotment?.inventory_merge_id && (
                <span>{allotment?.merged_project_name}</span>
              )}
            </div>
            {allotment?.unitof && <div><LeadStatusChip
              label={allotment?.unitof}
              style={{
                color: "#3538CD",
                backgroundColor: "#EEF4FF",
              }}
            /></div>}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper}>
              <div className={cssClasses.tokenStatus}>
                {!allotment?.sdrcomplete && (
                  <LeadStatusChip
                    label={"SDR Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                  />
                )}
                {allotment?.sdrcomplete && (
                  <LeadStatusChip
                    label={"SDR Complete"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
              </div>
            </div>
            <div className={cssClasses.tokenActions}>
              <ThreeDotsMenu
                list={allotment?.menuOptions}
                selectedValue={(e) => {
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(allotment.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                  if (e === "Timeline And Notes") {
                    setAllotmentData(allotment)
                    setcrmTimeLineModalToggle(true);
                  }
                  if (e === "Cancel Unit") {
                    let leadobj = {
                      leadId: allotment?.lead_id,
                      leadname: allotment?.lead_name,
                      leademail: allotment?.lead_email,
                      leadcontactnumber: allotment?.bookingformcontactnumber,
                      leaddisplayid: allotment?.leaddisplayid.toString(),
                    };
                    let allotmentObj = {
                      allotmentPaymentId: allotment?.allotment_payment_id,
                    };
                    setLeadObj(leadobj);
                    console.log("lead obj", leadobj, allotment)
                    setSelectedAllotment(allotmentObj);
                    setCancelUnitModal(true);
                  }
                  if (e === "Reassign CRM") {
                    setReassignCRMAllotment(allotment);
                    setReassignCRMModal(true);
                  }
                }}
              />
            </div>
          </div>
          <div className={cssClasses.leadDetailsDiv}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                className={cssClasses.tokenNumWrap}
                style={{ alignItems: "baseline" }}
              >
                <p>{allotment?.lead_name}</p>
                <p
                  style={{
                    fontFamily: "Inter-Regular",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "1.4rem",
                    lineHeight: "1.8rem",
                    color: "#667085",
                  }}
                >
                  {"VJ" +
                    allotment?.leaddisplayid?.toString()?.replace(
                      allotment?.leaddisplayid?.toString()?.substring(8, 12),
                      "-" +
                      allotment?.leaddisplayid?.toString()?.substring(8, 12)
                    )}
                </p>
              </div>
              <div className={cssClasses.allotmentPaymentId}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p>+91 {allotment?.bookingformcontactnumber}</p>
                </div>
                <p>{allotment?.allotment_payment_id}</p>
              </div>
              <div style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "space-between",
                marginTop: "1rem",
                width: "100%",
                flexDirection: "row"
              }}>
                {/* <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "start",
                  }}
                >
                  {allotment?.leadvjop && <div><LeadStatusChip
                    label="VJOP"
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                    }}
                  /></div>}
                  {allotment?.leadvjop &&
                    (allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
                      <LeadStatusChip
                        label="VJOP-LOYALTY"
                        style={{
                          color: "rgb(180, 35, 24)",
                          backgroundColor: "rgb(254, 243, 242)",
                          fontSize: "0.85rem",
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      />
                    ) : (
                      <LeadStatusChip
                        label="VJOP"
                        style={{
                          color: "rgb(180, 35, 24)",
                          backgroundColor: "rgb(254, 243, 242)",
                          fontSize: "0.85rem",
                          minWidth: "140px",
                          textAlign: "center",
                          
                        }}
                      />
                    ))}
                </div> */}
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "start",
                    marginTop: "1rem",
                    width: "100%",
                  }}
                >
                  {allotment?.leadvjop ? (
                    allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
                      <LeadStatusChip
                        label="VJOP-LOYALTY"
                        style={{
                          color: "rgb(180, 35, 24)",
                          backgroundColor: "rgb(254, 243, 242)",
                          fontSize: "0.85rem",
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      />
                    ) : (
                      <LeadStatusChip
                        label="VJOP"
                        style={{
                          color: "rgb(180, 35, 24)",
                          backgroundColor: "rgb(254, 243, 242)",
                          fontSize: "0.85rem",
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      />
                    )
                  ) : (
                    allotment?.leadtype && (
                      <LeadStatusChip
                        label={allotment.leadtype}
                        style={{
                          color: "rgb(24, 90, 180)",
                          backgroundColor: "rgb(240, 247, 255)",
                          fontSize: "0.85rem",
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      />
                    )
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "end",
                    width:"100%"
                  }}
                >
                  {allotment?.isdiscountapplied ? (
                    <LeadStatusChip
                      label={"Discount Applied"}
                      style={{ color: "#234a2e", backgroundColor: "#b8e6c4" }}
                    ></LeadStatusChip>
                  ) : (
                    allotment?.isdiscounteligible && (
                      <LeadStatusChip
                        label={"Discount Eligible"}
                        style={{
                          color: "#FF4F00",
                          backgroundColor: "#fad5be",
                        }}
                      ></LeadStatusChip>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={cssClasses.cardDetails}>
            <div className={cssClasses.tokenDetails}>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <span>
                  {" "}
                  {allotment?.event_title
                    ? allotment?.event_title
                    : "Sustenance "}{" "}
                </span>
                {allotment?.event_title &&
                  allotment?.pricing_type === "preselect" && (
                    <span>
                      <LeadStatusChip
                        label={"Preselect"}
                        style={{
                          color: "#3538CD",
                          backgroundColor: "#EEF4FF",
                        }}
                      />
                    </span>
                  )}
                <div className={cssClasses.tokenLastUpdate}>
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={allotment?.last_updated_at ?? allotment?.created_at}
                    locale="en-US"
                  />
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div className={cssClasses.tokenLastUpdate} style={{ flex: 1 }}>
                  <p>VJ SM - {allotment?.sales_user_name}</p>
                  {/* <p>VJ SM - {allotment.cpbillingname}</p> */}
                  {/* { allotment?.allotmentPaymentId?.crmuserid && allotment?.allotmentPaymentId?.crmusername && <p>VJ CRM - {allotment?.allotmentPaymentId?.crmusername}</p>} */}
                  {allotment?.crm_user_name && allotment?.crm_user_name && (
                    <p>VJ CRM - {allotment?.crm_user_name}</p>
                  )}
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  {allotment?.display_inventory_type?.includes(
                    "Inventory Type"
                  ) && <span>{allotment?.inventory_type}</span>}
                  {allotment?.display_inventory_type?.includes(
                    "Display Unit Type"
                  ) && <span>{"(" + allotment?.display_unit_type + ")"}</span>}
                  {!allotment?.inventory_type && <span>Merged</span>}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>Alloted By: </span>
                  <span>{allotment?.allotedbyuser}</span>
                </div>
                <div>
                  <span>Alloted On: </span>
                  <span>
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toDateString()},{" "}
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {allotment?.paymentplantitle &&
            <div style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              fontSize: "1.4rem",
              color: "rgba(220, 104, 3, 1)",
            }}>
              <span style={{ textTransform: "capitalize" }}>Payment Plan {allotment?.paymentplantitle} is selected.</span>
            </div>}
          <div className={cssClasses.cardFooter}>
            {!allotment?.is_approved && (loggedInUser?.roleId?.level == 1 ||
              loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Tag Pending"]?.["Approve Tag"]?.isAccessible)
              ? (<CardActions
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: 0,
                }}
              >
                <div>
                  <Button
                    disable={allotment?.isApproved}
                    style={{
                      color: "#fff",
                      backgroundColor: "#006AFF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                    }}
                    btnName={"Approve Tag"}
                    clicked={() => {
                      setSelectedCrmForApproveTag({ ...allotment });
                    }}
                  />
                </div>
                <div>
                  <Button
                    disable={allotment?.isApproved}
                    style={{
                      color: "#dc3545",
                      backgroundColor: "#FFFFFF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                      border: "1px solid #dc3545",
                    }}
                    btnName={"Reject Tag"}
                    clicked={() => {
                      setSelectedCrmForRejectTag({ ...allotment });
                    }}
                  />
                </div>
              </CardActions>
              ) : (
                <CardActions
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                  }}
                >
                  <div className={cssClasses.tokenStatus}>
                    {allotment?.is_tag_approve ? (
                      <LeadStatusChip
                        label={"Tag Approved"}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#027A48",
                          backgroundColor: "#ECFDF3",
                        }}
                      />
                    ) : (
                      <LeadStatusChip
                        label={"Tag Not Approved"}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "#B42318",
                          backgroundColor: "#FEF3F2",
                        }}
                      />
                    )}
                  </div>
                </CardActions>
              )}
          </div>
        </Card>
      </Grid>
    );
  });

  const handleAllSelect = () => {
    if (selectBtnName === "Select All") {
      setSelectBtnName("Remove All");
      setSelectedAllotmentDataToApprove(allCrmAllotments);
      setSelectedAllotments(allCrmAllotments);
    } else {
      setSelectBtnName("Select All");
      setSelectedAllotments([]);
    }
  };
  return (
    <>
      <div className={cssClasses.content}>
        <div
          className={cssClasses.actionWrapper}
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <div
            className={cssClasses.filterContainer}
            style={{ display: "flex", gap: "25px" }}
          >
            <div className={cssClasses.countWrapper}>
              {totalCount} Tag Pending
            </div>
          </div>
          <div className={cssClasses.filterContainer}>
            <div className={cssClasses?.filterWrapper}>
              {/* start filter implements */}
              <AllotmentFilter
                depStr={depStr}
                setDepQuery={setDepQuery}
                checked={checked}
                setChecked={setChecked}
                hasMore={hasMore}
                selectDates={selectDates}
                setSelectDates={setSelectDates}
                setAllCrmAllotments={setAllCrmAllotments}
                getCrmAllotmentsFromServer={getCrmAllotmentsFromServer}
                isTagPendingTab
                _loggedInUserId={
                  loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]
                    ?.CRM?.["Tag Pending"]?.["Approve Tag"]?.isAccessible
                    ? null
                    : !loggedInUser?.parentId
                      ? null
                      : loggedInUser?.id
                }
                pageNumber={pageNumber}
              />

              <AllotmentSortFilter
                allCrmAllotments={allCrmAllotments}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                setAllCrmAllotments={setAllCrmAllotments}
              />
              {/* end filter implements */}
              {/* <ViewToggleSwitch setMode={setMode} /> */}
            </div>
            <div
              className={cssClasses.searchWrapper}
              style={{ display: "flex", alignItems: "center", gap: "15px" }}
            >
              {mode === "Table View" && (
                <Button
                  style={{
                    color: "#fff",
                    backgroundColor: "#006AFF",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    fontFamily: "Inter-Medium !important",
                    width: "100px",
                  }}
                  btnName={"Approve"}
                  disable={selectedAllotments?.length === 0}
                  clicked={() => {
                    setShowApproveAlert(true);
                  }}
                />
              )}
              <SearchBar
                width="254px"
                sxStyle={{
                  "& input": {
                    fontSize: "1.3rem !important",
                    fontFamily: "Inter-Medium !important",
                  },
                }}
                placeholder={"Search by Lead Name Or Unit No"}
                search={debouncedFetchSearchData}
                id={"tagPendingCrmAllotmentLeadName"}
              />
            </div>
          </div>
        </div>

        {allCrmAllotments.length > 0 ? (
          <>
            {mode === "Card View" && (
              <Box
                id="scrollableDiv"
                className={cssClasses.mainTabPanelWrapper}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <InfiniteScroll
                    dataLength={allCrmAllotments.length}
                    next={() => {
                      if (hasMore.current) {
                        pageNumber.current = pageNumber.current + 1;
                        getCrmAllotmentsFromServer(true);
                      }
                    }}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      overflowY: "auto",
                    }} //To put endMessage and loader to the top.
                    hasMore={hasMore}
                    // loader={<p className={cssClasses.infiniteScrollLoadingText}>Loading...</p>}
                    scrollableTarget="scrollableDiv"
                  >
                    <Grid
                      style={{
                        marginTop: "0rem",
                        marginBottom: "1rem",
                        marginLeft: "0rem",
                        width: "100%",
                      }}
                      container
                      spacing={{ xs: 2, md: 3, lg: 3 }}
                      columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                    >
                      {allotmentCard}
                    </Grid>
                  </InfiniteScroll>
                  {/* </InfiniteScroll> */}
                </Box>
              </Box>
            )}
            {mode === "Table View" && (
              <div className={cssClasses.tableContainer}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label style={{ fontSize: "1.6rem" }}>
                    {/* {selectedAllotments?.length} Tag Selected */}
                    {selectBtnName === "Remove All" ? totalCount : selectedAllotments?.length} Tags Selected
                  </label>
                  <Button
                    btnName={selectBtnName}
                    style={{
                      color: "#fff",
                      width: "150px",
                      backgroundColor: "#006AFF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                    }}
                    clicked={() => {
                      handleAllSelect();
                    }}
                  />
                </div>
                <ServerPaginationGrid
                  sx={{
                    "& .MuiDataGrid-columnHeaders + div": {
                      height: "calc(100vh - 440px) !important",
                    },
                  }}
                  name="crm-tag-pending"
                  rows={allCrmAllotments}
                  columns={tagGridColumns}
                  depStr={depStr}
                  count={totalCount}
                  getDataByPage={getFilterAllotmentForDatagrid}
                />
              </div>
            )}
          </>
        ) : (
          <div style={{ height: "100%" }}>
            <p
              style={{
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                fontSize: "3rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={EmptyState} alt="No Data" />
                <span>No Allotment Available</span>
              </div>
            </p>
          </div>
        )}
      </div>

      {/* Approve Tag Confirmation Alert  */}
      {selectedCrmForApproveTag && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              approveCrmAllotmentTagToServer();
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => {
            setSelectedCrmForApproveTag(null);
          }}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to approve crm tagging?`}
          open={Boolean(selectedCrmForApproveTag)}
        />
      )}

      {showApproveAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              if (selectedAllotmentDataToApprove?.length > 0) {
                setShowApproveAlert(false);
                selectedAllotmentDataToApprove.map((val) =>
                  approveCrmAllotmentTagToServer(val)
                );
              }
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => {
            setShowApproveAlert(false);
          }}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to approve ${selectedAllotments?.length} crm allotment ?`}
          open={Boolean(showApproveAlert)}
        />
      )}

      {/* //! Reject Tag Confirmation Alert  */}
      {selectedCrmForRejectTag && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              rejectCrmAllotmentTagToServer();
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => {
            setSelectedCrmForRejectTag(null);
          }}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to reject crm allotment.`}
          open={Boolean(selectedCrmForRejectTag)}
        />
      )}
      {crm2RejectRow && (
        <RejectionReasonModal
          open
          handleClose={(r) => {
            const row = crm2RejectRow;
            if (r?.message === undefined) return setCrm2RejectRow(null);
            if (!String(r.message).trim()) return errorTost("Please enter the rejection reason");
            setCrm2RejectRow(null);
            crm2TagDecision(row, "reject", r.message);
          }}
        />
      )}
      {virtualAccountStatusModal && (
        <UpdateLeadDetails open={virtualAccountStatusModal}
          handleClose={() => {
            setVirtualAccountStatusModal(false);
          }}
          leadDisplayId={leadDisplayId}
        />
      )}
      {crmTimeLineModalToggle && (
        <CrmTimeLineModal
          open={true}
          data={allotmentData}
          handleClose={() => {
            setcrmTimeLineModalToggle(false);
          }}
        />
      )}
      {cancelUnitModal && (
        <CancelUnit
          open={cancelUnitModal}
          handleClose={() => {
            setCancelUnitModal(false);
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value) {
              dismissLoader();
              successTost("Cancellation done successfully!");
            }
          }}
          selectedAllotmentPass={selectedAllotment}
        />
      )}
      {reassignCRMModal && (
        <SelectCrmUserModal
          open={reassignCRMModal}
          crmUsersList={crmUsers}
          handleClose={() => { setReassignCRMModal(false) }}
          heading={"Reassign CRM"}
          allotment={reassignCRMAllotment}
        />
      )}
    </>
  );
}

export default TagPending;

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
